import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveCollaborationRequestList } from "./retrieve-collaboration-request-list";
import type { CollaborationRequestVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<CollaborationRequestVM[]> = { fetching: "idle", data: [] };

export const retrieveCollaborationRequestListReducer = createReducer<RetrievalState<CollaborationRequestVM[]>>(initialState, builder => {
  builder.addCase(retrieveCollaborationRequestList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveCollaborationRequestList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveCollaborationRequestList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
